const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "シンプルで透明性の高い価格設定で適切なプランを選択",
  monthlyUppercase: "毎月",
  montly: "毎月",
  free: "無料",
  yearlyUppercase: "毎年",
  yearly: "年間",
  inService: "サービス中",
  buyBtn: "今すぐ購入",
  freeTips1: "最大20MBのファイルサイズをサポートする",
  freeTips2: "1 日あたり6つのファイルを処理できます",
  freeTips3: "通常の処理速度",
  freeTips4: "通常のダウンロード速度",
  freeTips5: "1日に1枚の写真から背景を削除",
  freeTips52: "1日に3枚の写真から背景を削除",
  freeTips6: "すべての無料ツールの使用",
  vipTips1: "ファイルサイズ無制限",
  vipTips2: "ファイル数無制限",
  vipTips3: "ダウンロード速度が上がる",
  vipTips4: "処理速度が上がる",
  vipTips5: "無制限",
  vipTips6: "無制限で画像の背景を削除する",
  vipTips7: "機能は全て解放",
  vipTips8: "契約は自動的に更新され、いつでも解約できます。",
  vipTips9: "動画のサイズと数量には制限はありません",
  vipTips10: "画像背景の削除回数には制限はありません",
  vipTips11: "動画のダウンロードと処理速度が上がる",
  vipTips12: "全ての無料ツールとプレミアム機能を解放する",
  acceptTitle: "ご利用可能な支払方法",
  modalTitle: "プロにアップグレードして、全ての機能を解放する",
  total: "全て",
  enterCode: "コードを入力する",
  SignUpToPurchaseBtn: "登録して購入する",
  purchaseBtn: "購入する",
  saveTips: "最大{{num}}％割引",
  discount: "割引",
  purchaseTips: "契約は自動的に更新され、いつでも解約できます。",
  tips: "ヒント:",
  promoCodeInvalidTips: "販促コードが無限になりました。",
};

export default purchase;
